import CSVPreviewSection from './CSVPreviewSection'

export default function CSVPreviewCostProfitLossAdditionalSection() {}

CSVPreviewCostProfitLossAdditionalSection.prototype = new CSVPreviewSection();

CSVPreviewCostProfitLossAdditionalSection.prototype.init = function ( countDataColumns, countGroupingColumns, showOvertimeAddition, showLeaveTimeCosts )
{
    CSVPreviewSection.prototype.init.call( this );
    this.countGroupingColumns = countGroupingColumns;
    this.showOvertimeAddition = showOvertimeAddition;
    this.showLeaveTimeCosts = showLeaveTimeCosts;
    this.countDataColumns = countDataColumns;
    return this;
};

CSVPreviewCostProfitLossAdditionalSection.prototype.addRows = function ( tBody )
{
    if( this.showLeaveTimeCosts )
    {
        for( var i = 0; i < 2; ++i )
        {
            var row = this.createRow();
            this.addCell( row, this.message( "report.common.leave_type" ) );
            for( var k = 0; k < this.countGroupingColumns - 1; ++k )
            {
                ReportPreviewUtils.addEmptyCell( row );
            }
            for( k = 0; k < this.countDataColumns; ++k )
            {
                this.addTimeValueCell( row );
            }
            this.addRow( tBody, row );
        }
    }
    if( this.showOvertimeAddition )
    {
        row = this.createRow();
        this.addCell( row, this.message( "report.common.overtime_bonus" ), "overtimeBonus");
        for( k = 0; k < this.countGroupingColumns - 1; ++k )
            ReportPreviewUtils.addEmptyCell( row );
        for( k = 0; k < this.countDataColumns; ++k )
            this.addTimeValueCell( row );
        this.addRow( tBody, row );
      }
};

CSVPreviewCostProfitLossAdditionalSection.prototype.addGroupingLevel = function ( row, groupingLevel )
{
    ReportPreviewUtils.addCell( row, ReportPreviewUtils.getLevelPreviewName( groupingLevel ) );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/CSVPreviewCostProfitLossAdditionalSection.js